import { Select } from 'antd';
import { fetchCategories } from '../apis/categoriesApi';
import { useEffect, useState } from 'react';

const SelectCategory = ({ className = '', onChange, value }) => {
  const [options, setOptions] = useState([]);

  const loadCategories = async () => {
    const options = await fetchCategories(false, 1);
    setOptions(options);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <Select
      showSearch
      onChange={onChange}
      value={value}
      placeholder="Categoría"
      optionFilterProp="label"
      className={className}
      options={options.map((cateogory) => ({
        value: cateogory.id,
        label: cateogory.name,
      }))}
    />
  );
};

export default SelectCategory;
